import React from "react"
import { Trans, useTranslation } from "react-i18next"
import theme from "lib/material-ui/theme"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useForgetPasswordMutation } from "appRedux/slices/authApiSlice"
import { useAuth } from "context/AuthContext"
import CTA from "components/atoms/CTA"
import BottomSheet from "components/atoms/BottomSheet"

type SendOTPBottomSheetProps = {
  show: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export default function SendOTPBottomSheetForLoggedInUser(props: SendOTPBottomSheetProps) {
  const { show, onOpen, onClose } = props

  const { user } = useAuth()

  const { t } = useTranslation()

  const [triggerForgetPassword, forgetPasswordResult] = useForgetPasswordMutation()

  function handleSendOTP(event: any) {
    event.stopPropagation()
    event.preventDefault()
    if (!user?.email) return
    triggerForgetPassword(user.email)
  }

  return (
    <BottomSheet
      id="send-otp-logged-in-user-bottom-sheet"
      title={t("auth.forgotPassword")}
      show={show}
      openBottomSheet={onOpen}
      closeBottomSheet={onClose}
    >
      <form onSubmit={handleSendOTP} style={{ width: "100%", padding: "0 12px" }}>
        <Stack marginTop={4} alignItems="center">
          <img
            src="/static/images/email.png"
            alt="landing image"
            style={{ width: "124px", height: "auto" }}
          />
          <Message>
            <Trans
              i18nKey={"auth.emailSentToYourEmailForPasswordRecovery"}
              values={{ email: user?.email }}
              components={{
                strong: <strong style={{
                  color: theme.palette.gray["15"],
                  fontWeight: 700
                }}/>
              }}
            />
          </Message>
          <CTA
            variant="contained"
            type="submit"
            disabled={false}
            loading={forgetPasswordResult.isLoading}
            onClick={handleSendOTP}
          >
            {t("auth.sendOTP")}
          </CTA>
        </Stack>
      </form>
    </BottomSheet>
  )
}

const Message = styled(Typography)(({ theme }) => ({
  fontSize: "1.3rem",
  color: theme.palette.gray["14"],
  marginTop: "28px",
  marginBottom: "46px"
}))
